import React, {useEffect, useState} from 'react'
import withView from '../../cmn/docAutomation/withView';
import * as htmlToImage from 'html-to-image';
import * as fn from '../../../helper/uiFunctions';
import usePrintUsb from '../../../library/hooks/deviceIntegration/usePrintUsb';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormDialog from '../../../library/form/components/FormDialog';
import FormTitle from '../../../library/form/components/FormTitle'
import { UiGridColTwo, UiCol } from "../../../library/layout/Index";
import { PRINTER_TYPE_QR, API_SUPPORT_FOR_POS } from '../../../library/hooks/deviceIntegration/types';
import SarasInput from '../../../library/input/textField/SarasInput';

//reference to convert html to image https://www.npmjs.com/package/html-to-image
const DirectPrintPreview = (props) => {
    const { dynamicViewData, printType, serialNo } = props;

    const [printCopiesVal, setPrintCopiesVal] = useState(1);
    const printer = usePrintUsb(API_SUPPORT_FOR_POS, printType, serialNo);
    const anchorRef = React.useRef(null);
    
    const [imageData, setImageData] = useState(null);
    //for rendering the image in img html element
    const [imageSrc, setImageSrc] = useState(null);

    // console.log("report data", dynamicViewData);

    const showPrintState = (type, msg) => {
        // console.log("report printing state", type, msg);
    }

    // function getPixelRatio() {
    //     let ratio
      
    //     let FINAL_PROCESS
    //     try {
    //       FINAL_PROCESS = process
    //     } catch (e) {
    //       // pass
    //     }
      
    //     const val =
    //       FINAL_PROCESS && FINAL_PROCESS.env
    //         ? FINAL_PROCESS.env.devicePixelRatio
    //         : null
    //     if (val) {
    //       ratio = parseInt(val, 10)
    //       if (Number.isNaN(ratio)) {
    //         ratio = 1
    //       }
    //     }
    //     return ratio || window.devicePixelRatio || 1
    // }
    
    const onPrintRender = () => {
        // console.log("report node", anchorRef.current);

        if(anchorRef.current && printType !== PRINTER_TYPE_QR){
            let node = anchorRef.current;

            let innerDiv = node.getElementsByClassName("uiRptMainContainer");
            // console.log("supported devices 1", node.offsetWidth, innerDiv, innerDiv.length, innerDiv[0].offsetWidth);

            if(innerDiv.length > 0){
                //for testing of the printer issue add 20 px to render black border
                // node.style.width = (innerDiv[0].offsetWidth + 20) + "px";
                node.style.width = innerDiv[0].offsetWidth + "px";
            }

            // console.log("supported devices 2", node.offsetWidth, innerDiv, innerDiv.length, innerDiv[0].offsetWidth);

            htmlToImage.toJpeg(node, { quality: 1 })
            .then(function (dataUrl) {
                setImageSrc(dataUrl);
            });

            //hardcoded pixel ratio since there is a bug in htmltoimage function
            //more research is required, it seems that the printout is calibrated for pixelRatio 2
            htmlToImage.toCanvas(node, { pixelRatio: 2 })
            .then(function (canvas) {
                // console.log("image pixel count in canvas", canvas.width, canvas.height);

                var xyData = [];

                const imageSize = {width:canvas.width, height:canvas.height};
                const ctx = canvas.getContext('2d');

                //don't take further action if the report is missing
                if(canvas.width === 0 || canvas.height === 0) return;

                var pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
                
                // console.log("image pixel count in canvas", pixels.length, imageSize.height * imageSize.width * 4);

                for (var y = 0; y < imageSize.height; ++y) {
                xyData.push([]);

                for (var x = 0; x < imageSize.width; ++x) {
                    var pixelAtXYOffset = (4 * y * imageSize.width) + (4 * x);
                    /* pixelAtXY is a Uint8Array[4] containing RGBA values of the pixel at (x, y) in the range 0..255 */
                    xyData[y][x] = pixels.slice(pixelAtXYOffset, pixelAtXYOffset + 4);
                }
                }
                
                const newImageData = {...imageSize, data: xyData};

                setImageData(newImageData);

                printer.setCallback(showPrintState);
                
                printImageReceipt(null, newImageData);
            });
        }
    }
    
    useEffect(onPrintRender, [anchorRef]);
    
    const onPrintBarCode = () => {
        if(printType === PRINTER_TYPE_QR){
            printBarCode();
        }
    }

    useEffect(onPrintBarCode, []);

    const printImageReceipt = (e, newImageData) => {
        // console.log("report print trigger", newImageData, imageData);
        
        if(newImageData || imageData){
            var printData = {
                isImage: true,
                data: newImageData || imageData
            };

            printer.sendData(printData);
        }
    }

    const printBarCode = () => {
        // console.log("device print", printCopiesVal, dynamicViewData.viewData.replace("$noOfCopies$", printCopiesVal));
        
        if(dynamicViewData && dynamicViewData.viewData){
            var printData = {
                printType: PRINTER_TYPE_QR,
                data: dynamicViewData.viewData.replace(/\$noOfCopies\$/g, printCopiesVal)
                // data:  dynamicViewData.viewData.replace("$noOfCopies$", printCopiesVal)
            };

            printer.sendData(printData);
        }
    }

    const renderDynamicHtml = () => {
        return {__html: dynamicViewData.viewData};
    }

    const renderDeviceState = () => {
        // console.log("device render", isDeviceConnected);
    
        if(printer.isDevicePaired){
          return (
            <div style={{margin:"10px 0px",textAlign:"center"}}>
              <span style={{color:"green"}}><SarasTrans value = "Printer paired"/></span>
              {
                printer.isDeviceConnected ? <span style={{color:"green"}}>, <SarasTrans value = "Printer is connected"/></span> 
                                    : <span style={{color:"red"}}>, <SarasTrans value = "Printer is disconnected or off"/></span>
              }
            </div>
          )
        }
        else{
          return (
            <div style={{margin:"10px 0px",textAlign:"center"}}>
              <span style={{color:"red",display:"block"}}><SarasTrans value = "Printer not paired"/></span>
              <button className='uiActionButtonBasic' 
                onClick={() => printer.requestDevicePermission()}><SarasTrans value = "Connect Printer"/></button>
            </div>
          )
        }
    }

    const onInputChange = (e, value) => {
        // console.log("txt value", value);
        setPrintCopiesVal(value);
    }

    const renderBarCodePrinter = () => {
        return (
            <>
                <span style={{color:"blue"}}><SarasTrans value = "Print Copies"/></span>
                <SarasInput style={{width:"50px"}} className="uiSpacerH5" onChange={onInputChange} type='input' value={printCopiesVal} />
                <button className='uiActionButtonBasic'
                onClick={printBarCode}>Print</button>
            </>
        )
    }

    return (
        <UiGridColTwo>
            <UiCol>
                <div style={{overflow:"auto", height: '400px'}}>
                    {
                        printType === PRINTER_TYPE_QR ? null : <div style={{overflow:"visible"}}
                        ref={anchorRef} id='rpt-print-receipt' 
                        dangerouslySetInnerHTML={renderDynamicHtml()} />
                    }
                </div>
            </UiCol>
            <UiCol>
                <div style={{textAlign:"center"}}>
                    {renderDeviceState()}
                    <div style={{margin:"90px 0px"}}>
                        {
                            printType === PRINTER_TYPE_QR 
                            ?  renderBarCodePrinter()
                            : <button className='uiActionButton'
                            onClick={printImageReceipt}><SarasTrans value = "Print"/></button>
                        }
                        {
                            printType === PRINTER_TYPE_QR ? null :<a className='uiActionButtonBasic' style={{marginLeft:"3px"}}
                            href={imageSrc}
                            download={`Receipt_${fn.getTicks()}`}><SarasTrans value = "Download"/></a>
                        }
                    </div>
                </div>
            </UiCol>
        </UiGridColTwo>
    )
}

const DirectPrint = (props) => {
    const { formObject, viewData, dynamicViewData, ...restProps } = props;

    const printType = dynamicViewData.action.actionParam.printType || 'slip';
    const serialNo = dynamicViewData.action.actionParam.serialNo;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forCancel: "Close" } }}
            formStyle={{ height: '550px' }}
            contentStyle={{ width: "430px" }}
            formTitle={<FormTitle formObject={formObject} value='Print Preview' />}
            formObject={formObject} >
                <DirectPrintPreview printType={printType} serialNo={serialNo} dynamicViewData={dynamicViewData}/>
        </FormDialog>
    )
}

export default withView(DirectPrint, "directPrint", "directPrint");
